<template>
  <div>
    <v-card
      class="px-4"
      outlined
    >
      <v-row
        no-gutters
        class="px-4 py-4"
      >
        <v-col
          cols="12"
          :sm="12"
        >
          <v-alert
            v-if="isFormValid && showResult"
            dense
            outlined
            :type="hasError ? 'error': 'success'"
          >
            {{ hasError ? 'Операция выполнена с ошибками проверьте файл!' :
              'Операция успешно выполнена!' }}
          </v-alert>
        </v-col>
        <v-col
          cols="12"
          :sm="12"
        >
          <v-list-item class="px-0 mx-0">
            <v-list-item-action>
              <v-btn
                v-if="officeImportModel.file"
                icon
                color="error"
                @click="onDeleted"
              >
                <v-icon>
                  mdi-delete
                </v-icon>
              </v-btn>
              <WBDFileUploaderBtn
                v-else
                :label="'Аватар'"
                :loaded-event="eventNames.OFFICE_IMPORT_FILE_LOADED"
                :deleted-event="eventNames.OFFICE_IMPORT_DELETE_FILE"
                :file-key="'dictionary-avatar'"
                :mimeTypes="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                :callback="onFileSaved"
                icon
              />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <a
                  v-if="officeImportModel.file"
                  target="_blank"
                  :href="officeImportModel.file.path"
                >
                  <v-btn
                    style="background-color: transparent"
                  >
                    <span style="color: #1976d2">Скачать файл для проверки</span>
                  </v-btn>
                </a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-btn
          :disabled="!isFormValid"
          color="info"
          text
          @click="clear"
        >
          Отменить
        </v-btn>
        <v-spacer />
        <v-btn
          :disabled="!isFormValid"
          text
          outlined
          rounded
          color="success"
          class="ml-6 my-4"
          @click="submit(true)"
        >
          Проверить файл
        </v-btn>
        <v-btn
          :disabled="!isFormValid || hasError"
          rounded
          class="ml-6 my-4 success"
          @click="submit(false)"
        >
          Импортировать
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import OrganizationMixin from '@/mixins/organizationMixin.vue'
import { mapMutations } from 'vuex'
import storeUtils from '@/utils/store'
import storeLabel from '@/store/labels'
import WBDFileUploaderBtn from '@/components/common/files/file-uploader-btn'

export default {
  name: 'OfficeImportComponent',
  components: {
    WBDFileUploaderBtn,
  },
  mixins: [OrganizationMixin],
  props: {
    organization: Object,
    action: String,
  },
  data: () => ({
    dictionaries: { legalFormTypeList: [] },
    fileKey: 'offer-import',
    showResult: false,
    hasError: false,
    officeImportModel: {
      id: null,
      organization: null,
      file: null,
    }
  }),
  computed: {
    isFormValid () {
      return !!this.officeImportModel.file && this.organization &&
          this.organization.id
    }
  },
  watch: {
  },

  async created () {
  },
  methods: {
    ...mapMutations({
      setFileEvents: storeUtils.setterName(storeLabel.FILE_EVENTS, storeLabel.COMMON_MODULE),
    }),
    onDeleted () {
      this.officeImportModel.file = null
      this.hasError = false
    },
    async submit (dryRun) {
      try {
        this.hasError = false
        this.showResult = true
        if (this.officeImportModel.file) {
          const file = this.officeImportModel.file
          this.showPageLoader()
          const response = await this.$store.dispatch(
            this.action,
            {
              media: {
                id: file.id,
              },
              organization: {
                id: this.organization.id,
              },
              dryRun,
            }
          )
          const responseData = response.data
          if (responseData && responseData.errorCounter && !!responseData.errorCounter) {
            this.hasError = true
            this.showErrorNotification('Операция выполнена с ошибками проверьте файл!')
          } else {
            this.showSuccessNotification('Операция выполнена')
          }
          this.hidePageLoader()


          if (!dryRun) {
            if (responseData && responseData.entityCounter && !!responseData.entityCounter) {
              this.$emit('onSuccessCallback', responseData.entityCounter)
            }
          }
        }
      } catch (error) {
        this.showErrorNotification('Ошибка при выполнении запроса!')
      }
    },
    clear () {
      this.officeImportModel = {
        id: null,
        organization: null,
        file: null,
      }
    },
    onFileSaved (response) {
      this.officeImportModel.file = response
    },
  }
}
</script>
<style lang="scss" scoped>
.office-item {
  cursor: pointer;
}
</style>

